import Home from "../../../components/Home/Home";

const HomePage = () => {
    return (
        <Home></Home>
    );
}

export default HomePage;
